export default {
  smallQuantity: {
    fontSize: 56,
    quantityYPosition: 100,
    unitYPosition: 122,
  },
  mediumQuantity: {
    fontSize: 48,
    quantityYPosition: 100,
    unitYPosition: 122,
  },
  largeQuantity: {
    fontSize: 32,
    quantityYPosition: 93,
    unitYPosition: 115,
  },
};
